export default {
    Auth0ClientId: 'tnZd7b5I3Ho1FmEMvMwktyVA0AqBkt3f',
    Auth0Domain: 'talenya.eu.auth0.com',
    Auth0ResponseType: 'token id_token',
    Auth0RedirectUrl: window.location.href.replace(window.location.hash, ''),
    Auth0Leeway: 60,
    SentryioKey: 'https://7f67efdcc5f2490b800be48d1cbec5fa@sentry.io/1260059',
    Inlinemanual: true,
    EnforceSSL: true,
};
